import React, { useState, useEffect } from "react";
import {
  Box,
  Heading,
  FormControl,
  FormLabel,
  Select,
  Button,
  Alert,
  AlertIcon,
  Stack,
  Text,
  useToast,
  Spinner,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
} from "@chakra-ui/react";
import { useParams,useHistory } from "react-router-dom";
import axios from "axios";
import config from "config";
import { getToken } from "utils/auth";

const EditFamily = () => {
  const { familyCode } = useParams();
  const toast = useToast();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // Alert dialog states
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const cancelRef = React.useRef();
  const history = useHistory();

  useEffect(() => {
    const token = getToken()
    axios
      .get(`${config.API_URL}/individuals/families/${familyCode}`, {
        headers: { Authorization: `Bearer ${token}` }})
      .then((response) => {
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching family data:", err);
        setError("Failed to fetch family details.");
        setLoading(false);
      });
  }, [familyCode]);


  const confirmDelete = () => {
    const token = getToken()
    axios
      .delete(`${config.API_URL}/individuals/families/${familyCode}`,{
        headers: { Authorization: `Bearer ${token}` }})
      .then(() => {
        toast({
          title: "Family deleted successfully.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });

        history.push("/txd/families");

      })
      .catch((err) => {
        console.log(err.message)
        console.error("Error deleting family:", err.message);
        toast({
          title: "Error deleting family:" + err.message,
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      });
  };

  if (loading) {
    return (
      <Box p={6} textAlign="center">
        <Spinner size="xl" />
        <Text mt={4}>Loading family details...</Text>
      </Box>
    );
  }

  if (error) {
    return (
      <Box p={6}>
        <Alert status="error" borderRadius="md">
          <AlertIcon />
          {error}
        </Alert>
      </Box>
    );
  }

  return (
    <Box p={6} bg="white" shadow="md" borderRadius="lg" maxW="600px" mx="auto">
      <Heading mb={6}>Edit Family: {familyCode}</Heading>
      <form>
        
        <Stack direction="row" spacing={4} mt={6}>

          <Button
            colorScheme="red"
            flex={1}
            onClick={() => setIsDialogOpen(true)}
          >
            Delete Family
          </Button>
        </Stack>
      </form>

      {/* Confirmation Dialog */}
      <AlertDialog
        isOpen={isDialogOpen}
        leastDestructiveRef={cancelRef}
        onClose={() => setIsDialogOpen(false)}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Delete Family
            </AlertDialogHeader>
            <AlertDialogBody>
              Are you sure you want to delete this family and all its related
              individuals? This action cannot be undone.
            </AlertDialogBody>
            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={() => setIsDialogOpen(false)}>
                Cancel
              </Button>
              <Button
                colorScheme="red"
                onClick={() => {
                  confirmDelete();
                  setIsDialogOpen(false);
                }}
                ml={3}
              >
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Box>
  );
};

export default EditFamily;
